module.exports = __webpack_public_path__ + "img/hand2-landing.297b1fe5.jpg";